import { useMemo } from 'react'

import { IndikatorPerencanaanPanel } from 'app/KinerjaShared/components/IndikatorPerencanaanPanel'

import type { KinerjaUtamaDetail } from 'types/kinerja'

export type TugasPokokItemsPros = {
  originalIds: Array<number>
  contents: Array<KinerjaUtamaDetail>
  orderNumber: number
}

export function TugasPokokItems({
  originalIds,
  contents,
  orderNumber,
}: TugasPokokItemsPros) {
  const contentsMap: Record<number, KinerjaUtamaDetail> = useMemo(() => {
    return contents.reduce((acc, content) => {
      acc[content.id] = content
      return acc
    }, {} as Record<number, KinerjaUtamaDetail>)
  }, [contents])

  return (
    <>
      {originalIds.map((id, index) => {
        const resolvedOrderNumber = `${orderNumber}.${index + 1}`

        return (
          <IndikatorPerencanaanPanel
            key={`tugas-pokok-${id}`}
            variant="static"
            orderNumber={resolvedOrderNumber}
            title={contentsMap[id]?.rencanaHasilKerja}
          />
        )
      })}
    </>
  )
}
